import Tooltip from '@material-ui/core/Tooltip';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { autonomousProvinces } from '../../constants/globals';
import ModalForAddOrUpdatePlace from './ModalForAddOrUpdatePlace';
import ModalForAddPlaceToAutonomousProvince from './ModalForAddPlaceToAutonomousProvince';

class PlaceRow extends Component {
  constructor() {
    super();
    this.state = {
      showPlace: false,
      showModalForUpdateName: false,
    };
  }

  handleClose = () => {
    this.setState({ showPlace: false, showModalForUpdateName: false });
  };

  handleOpen = () => {
    this.setState({ showPlace: true });
  };

  handleOpenUpdateName = () => {
    this.setState({ showModalForUpdateName: true });
  };

  updatePlace = (place) => {
    const { NotificationMessages } = this.props.translations;
    this.props.updatePlace(place, this.handleClose, NotificationMessages);
  };
  render() {
    const { index, place, translations } = this.props || {},
      { name } = place || {},
      { Tooltips } = translations;

    const autonomousProvinceTranslate =
      autonomousProvinces[place.autonomousProvince]?.text;

    const row = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{name}</td>
        <td>{autonomousProvinceTranslate}</td>
        <td>
          <Link onClick={this.handleOpen} to="#">
            <Tooltip
              title={Tooltips.updateAutonomousProvnice}
              placement="top"
              arrow={true}
            >
              <i className="fas fa-pen fa-2x" />
            </Tooltip>
          </Link>
        </td>
        <td>
          <Link onClick={this.handleOpenUpdateName} to="#">
            <Tooltip
              title={Tooltips.updatePlaceName}
              placement="top"
              arrow={true}
            >
              <i className="fas fa-edit fa-2x" />
            </Tooltip>
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {row}
        {this.state.showPlace && (
          <ModalForAddPlaceToAutonomousProvince
            show={this.state.showPlace}
            handleClose={this.handleClose}
            place={place}
            updatePlace={this.updatePlace}
          />
        )}
        {this.state.showModalForUpdateName && (
          <ModalForAddOrUpdatePlace
            show={this.state.showModalForUpdateName}
            handleClose={this.handleClose}
            place={place}
            updatePlace={this.updatePlace}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(PlaceRow, 'PlaceRow');
